import { UserEligibilityForPreLaunchResponse } from '../../types/rewards';

export const getUserEligibilityForPreLaunchModel = (response: UserEligibilityForPreLaunchResponse): UserEligibilityForPreLaunchResponse => response;
